(() => {
  const menuButton = document.querySelector('.menu-toggle');
  const navigation = document.querySelector('#primary-navigation');
  if (menuButton && navigation) {
    const mobileViewport = window.matchMedia('(max-width: 1023px)');
    const syncMenu = () => {
      menuButton.hidden = !mobileViewport.matches;
      navigation.hidden = mobileViewport.matches && menuButton.getAttribute('aria-expanded') !== 'true';
    };
    menuButton.addEventListener('click', () => {
      menuButton.setAttribute('aria-expanded', String(menuButton.getAttribute('aria-expanded') !== 'true'));
      syncMenu();
    });
    navigation.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileViewport.matches) {
        menuButton.setAttribute('aria-expanded', 'false');
        syncMenu();
        menuButton.focus();
      }
    });
    menuButton.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menuButton.setAttribute('aria-expanded', 'false');
        syncMenu();
      }
    });
    mobileViewport.addEventListener('change', syncMenu);
    syncMenu();
  }

  const header = document.querySelector('.site-header');
  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-height', `${header.getBoundingClientRect().height}px`);
    }).observe(header);
  }

  document.querySelectorAll('[data-seasonal-rail]').forEach((rail) => {
    rail.addEventListener('keydown', (event) => {
      if (event.target !== rail || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      if (rail.scrollWidth <= rail.clientWidth) return;
      event.preventDefault();
      const distance = (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth) + 16;
      if (event.key === 'Home') rail.scrollLeft = 0;
      else if (event.key === 'End') rail.scrollLeft = rail.scrollWidth;
      else rail.scrollBy({ left: event.key === 'ArrowRight' ? distance : -distance, behavior: 'auto' });
    });
  });

  const core = window.NFCCart;
  if (!core) return;
  document.querySelectorAll('[data-nfc-custom-registry]').forEach((source) => {
    try { core.registerCustomVariants(JSON.parse(source.textContent)); } catch {}
  });
  document.querySelectorAll('[data-nfc-product-state]').forEach((source) => {
    try { core.registerVariants(JSON.parse(source.textContent).variants.map((variant) => variant.id)); } catch {}
  });
  core.registerVariants([...document.querySelectorAll('[data-cart-variant]')].map((element) => element.dataset.cartVariant));
  const recovery = document.querySelector('[data-cart-recovery]');
  const recoveryMessage = recovery?.querySelector('[data-recovery-message]');
  const reconcileButton = recovery?.querySelector('[data-cart-reconcile]');
  let viewPending = false;
  const quantityChanges = new Map();
  let quantityTimer;
  let quantityFlushing = false;
  let storage;
  try { storage = window.sessionStorage; } catch {}
  const syncState = (state) => {
    document.querySelectorAll('[data-nfc-custom]').forEach((root) => root.dispatchEvent(new CustomEvent('nfc:custom-lock', { detail: { locked: state.locked || viewPending, pending: state.pending || viewPending, uncertain: state.uncertain } })));
    document.querySelectorAll('.product-form').forEach((form) => { form.dataset.cartLocked = String(state.locked || viewPending); });
    document.querySelectorAll('.product-form button, .product-form input[name="quantity"], [data-cart-change] button, [data-cart-change] input[name="quantity"]').forEach((control) => {
      if (control.dataset.originalDisabled === undefined) control.dataset.originalDisabled = String(control.disabled);
      control.disabled = state.locked || viewPending || control.dataset.originalDisabled === 'true';
    });
    document.querySelectorAll('[data-cart-checkout] button').forEach((button) => {
      button.disabled = state.locked || viewPending || quantityFlushing || quantityChanges.size > 0 || !!document.querySelector('[data-cart-change] [aria-invalid="true"]');
    });
    if (recovery && state.uncertain) recovery.hidden = false;
    if (reconcileButton) reconcileButton.disabled = state.pending || viewPending;
  };
  const client = core.createClient({ fetchImpl: window.fetch.bind(window), origin: window.location.origin, routes: document.body.dataset, storage, onState: syncState });
  client.seedKeys([...document.querySelectorAll('[data-cart-change] input[name="id"]')].map((input) => input.value));
  document.querySelectorAll('.product-form').forEach((form) => { form.noValidate = true; });
  syncState(client.state());
  const statusFor = (form, text, error = false) => {
    const status = form.querySelector('[data-form-status]');
    if (!status) return;
    status.textContent = text;
    status.classList.toggle('error', error);
    status.setAttribute('role', error ? 'alert' : 'status');
  };
  const syncCount = (cart) => document.querySelectorAll('[data-bag-count]').forEach((element) => { element.textContent = String(cart.item_count); });
  document.addEventListener('nfc:custom-submit', async (event) => {
    const { root, formData, variantId, musicRequested, layoutId } = event.detail || {};
    if (!root || !formData || !root.matches('[data-nfc-custom]')) return;
    if (client.state().locked || viewPending) {
      root.dispatchEvent(new CustomEvent('nfc:custom-result', { detail: { kind: 'blocked', message: 'Check the current cart before trying again.' } }));
      return;
    }
    let customConfig;
    try { customConfig = JSON.parse(root.querySelector('[data-nfc-custom-config]').textContent); } catch {
      root.dispatchEvent(new CustomEvent('nfc:custom-result', { detail: { kind: 'rejected', message: 'Customization is temporarily unavailable.' } }));
      return;
    }
    const selectedLayout = customConfig.family === 'cassette' && Array.isArray(customConfig.layouts) ? customConfig.layouts.find(layout => layout.id === layoutId) : null;
    if (customConfig.family === 'cassette' && Array.isArray(customConfig.layouts) && !selectedLayout) {
      root.dispatchEvent(new CustomEvent('nfc:custom-result', { detail: { kind: 'rejected', message: 'Choose a print layout before adding your design.' } }));
      return;
    }
    const selection = selectedLayout || customConfig;
    const chosen = musicRequested ? selection.musicVariant : selection.photoVariant;
    if (!chosen || String(chosen.id) !== String(variantId) || !chosen.available) {
      root.dispatchEvent(new CustomEvent('nfc:custom-result', { detail: { kind: 'rejected', message: 'This custom option is unavailable.' } }));
      return;
    }
    core.registerCustomVariants([
      { id: selection.photoVariant.id, music: false, family: customConfig.family, imageCount: customConfig.imageCount, printLayout: selectedLayout?.label },
      ...(selection.musicVariant ? [{ id: selection.musicVariant.id, music: true, family: customConfig.family, imageCount: customConfig.imageCount, printLayout: selectedLayout?.label }] : [])
    ]);
    const result = await client.mutate('custom', formData);
    if (result.kind === 'success') {
      syncCount(result.cart);
      if (recovery) recovery.hidden = true;
    } else if (result.kind === 'uncertain' && recoveryMessage) {
      recoveryMessage.textContent = 'Photo upload could not be confirmed. Check your cart before retrying; do not duplicate this design.';
    }
    root.dispatchEvent(new CustomEvent('nfc:custom-result', { detail: result }));
  });
  const quantityFor = (form, allowZero = false) => {
    const input = form.querySelector('[name="quantity"]');
    const error = form.querySelector('[data-quantity-error]');
    try {
      const quantity = core.parseQuantity(input.value, { min: input.dataset.min || input.min, increment: input.dataset.step || input.step, max: input.dataset.max || input.max }, allowZero);
      input.removeAttribute('aria-invalid');
      if (error) error.textContent = '';
      return quantity;
    } catch (problem) {
      input.setAttribute('aria-invalid', 'true');
      if (error) error.textContent = problem.message;
      input.focus();
      throw problem;
    }
  };
  const refreshCart = async (focusIndex = 0) => {
    const current = document.querySelector('[data-cart-section]');
    if (!current) return;
    const url = new URL(document.body.dataset.cartUrl, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Invalid cart document route.');
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000) });
    if (!response.ok) throw new Error('Cart display could not be refreshed.');
    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    const replacement = documentFragment.querySelector('[data-cart-section]');
    if (!replacement || replacement.querySelector('script')) throw new Error('Cart display was incomplete.');
    current.replaceWith(document.importNode(replacement, true));
    const controls = document.querySelectorAll('[data-cart-change] input[name="quantity"]');
    const destination = controls[Math.min(focusIndex, controls.length - 1)] || document.querySelector('[data-cart-heading]');
    destination?.focus({ preventScroll: true });
    syncState(client.state());
  };
  const perform = async (form, kind, body, shopPay = false) => {
    if (client.state().locked || viewPending) return;
    viewPending = true;
    syncState(client.state());
    const focusIndex = Math.max(0, [...document.querySelectorAll('[data-cart-change]')].indexOf(form));
    const submit = form.querySelector('button[type="submit"]');
    const label = submit?.textContent;
    if (submit) submit.textContent = kind === 'add' ? 'Adding…' : 'Updating…';
    form.setAttribute('aria-busy', 'true');
    statusFor(form, kind === 'add' ? 'Adding…' : 'Updating…');
    const result = await client.mutate(kind, body);
    try {
      if (result.kind === 'success') {
        syncCount(result.cart);
        if (recovery) recovery.hidden = true;
        if (kind === 'change') {
          await refreshCart(focusIndex);
          const status = document.querySelector('[data-cart-status]');
          if (status) status.textContent = body.quantity === 0 ? 'Item removed.' : 'Cart updated.';
        } else {
          statusFor(form, shopPay ? 'Opening Shop Pay…' : 'Added to cart.');
          if (shopPay) window.location.assign(new URL(document.body.dataset.cartUrl.replace(/\/cart\/?$/, '/checkout') + '?payment=shop_pay', window.location.origin).href);
        }
      } else if (result.kind !== 'blocked') {
        statusFor(form, result.message, true);
        if (result.kind === 'uncertain' && recoveryMessage) recoveryMessage.textContent = result.message;
      }
    } catch {
      client.markUncertain();
      if (recoveryMessage) recoveryMessage.textContent = 'The change was accepted, but the cart display could not be refreshed. Check your cart before trying again.';
    } finally {
      if (submit) submit.textContent = label;
      form.setAttribute('aria-busy', 'false');
      viewPending = false;
      syncState(client.state());
    }
    return result;
  };
  // Debounce typing and serialize changes so only confirmed Shopify totals are shown.
  const flushQuantities = async () => {
    clearTimeout(quantityTimer);
    if (quantityFlushing || client.state().locked || viewPending) return;
    quantityFlushing = true;
    try {
      while (quantityChanges.size && !client.state().locked) {
        const [key, quantity] = quantityChanges.entries().next().value;
        quantityChanges.delete(key);
        const form = [...document.querySelectorAll('[data-cart-change]')].find((entry) => entry.querySelector('[name="id"]').value === key);
        if (!form) continue;
        const result = await perform(form, 'change', { id: key, quantity });
        if (result?.kind !== 'success') {
          form.querySelector('[name="quantity"]').setAttribute('aria-invalid', 'true');
          quantityChanges.clear();
          break;
        }
        // The server-rendered section may replace other rows queued before this request.
        document.querySelectorAll('[data-cart-change]').forEach((entry) => {
          const desired = quantityChanges.get(entry.querySelector('[name="id"]').value);
          if (desired !== undefined) entry.querySelector('[name="quantity"]').value = String(desired);
        });
      }
    } finally { quantityFlushing = false; syncState(client.state()); }
  };
  const scheduleQuantity = (form, delay = 300) => {
    if (client.state().locked || viewPending) return;
    const key = form.querySelector('[name="id"]').value;
    try {
      const quantity = quantityFor(form, true);
      statusFor(form, 'Updating…');
      quantityChanges.set(key, quantity);
      clearTimeout(quantityTimer);
      quantityTimer = setTimeout(flushQuantities, delay);
    } catch (error) { quantityChanges.delete(key); statusFor(form, error.message, true); }
    syncState(client.state());
  };
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-cart-change] [name="quantity"]')) scheduleQuantity(event.target.closest('form'));
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-change] [name="quantity"]')) scheduleQuantity(event.target.closest('form'), 0);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('[data-cart-checkout]')) {
      if (client.state().locked || viewPending || quantityFlushing || quantityChanges.size || document.querySelector('[data-cart-change] [aria-invalid="true"]')) event.preventDefault();
      return;
    }
    if (!form.matches('.product-form, [data-cart-change]')) return;
    event.preventDefault();
    if (client.state().locked || viewPending) return;
    try {
      if (form.matches('.product-form')) {
        const variant = form.querySelector('[data-variant-id]');
        const button = form.querySelector('[data-add-button]');
        if (!variant || !core.knownVariants.has(variant.value) || button.dataset.available !== 'true' || button.dataset.planRequired === 'true') throw new Error('This option is currently unavailable. Please choose another option.');
        void perform(form, 'add', { items: [{ id: variant.value, quantity: quantityFor(form) }] }, !!event.submitter?.hasAttribute('data-nfc-shop-pay'));
      } else scheduleQuantity(form, 0);
    } catch (error) { statusFor(form, error.message, true); }
  });
  document.addEventListener('click', (event) => {
    const adjust = event.target.closest('[data-quantity-adjust]');
    if (adjust) {
      const form = adjust.closest('form');
      if (!form || client.state().locked || viewPending) return;
      try {
        const input = form.querySelector('[name="quantity"]');
        const quantity = quantityFor(form);
        const increment = Number(input.step || 1);
        const next = quantity + Number(adjust.dataset.quantityAdjust) * increment;
        input.value = String(core.parseQuantity(next, { min: input.min, increment, max: input.max }));
      } catch (error) { statusFor(form, error.message, true); }
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      const form = remove.closest('[data-cart-change]');
      if (form && !client.state().locked && !viewPending) {
        quantityChanges.set(remove.dataset.key, 0);
        void flushQuantities();
      }
    }
  });
  reconcileButton?.addEventListener('click', async () => {
    if (client.state().pending || viewPending) return;
    viewPending = true;
    syncState(client.state());
    recoveryMessage.textContent = 'Checking the current cart. No change will be retried.';
    const result = await client.reconcile();
    if (result.kind === 'success') {
      try {
        syncCount(result.cart);
        await refreshCart();
        recoveryMessage.textContent = 'Cart checked: ' + result.cart.item_count + ' items. Review the cart before making another change. No request was retried.';
      } catch {
        client.markUncertain();
        recoveryMessage.textContent = 'Cart display could not be refreshed. No change was retried.';
      }
    } else if (result.message) recoveryMessage.textContent = result.message;
    viewPending = false;
    syncState(client.state());
  });
})();
